import config from 'modules/common/config';

// Where a sign-out lands other than /login. Auth0 allows only /login as a post-logout return,
// so the destination waits in this tab across the tenant's logout and /login applies it. A
// closed set, mapped to URLs here, so a stored value can never become an open redirect.
export type AfterSignOut = 'companyHome';

const KEY = 'auth0AfterSignOut';

// The tenant's logout is a couple of redirects. Anything older is from a sign-out that never
// arrived, and must not send a later visit to /login somewhere else.
const MAX_AGE_MS = 2 * 60 * 1000;

export function rememberAfterSignOut(value: AfterSignOut): void {
    window.sessionStorage.setItem(KEY, JSON.stringify({ value, at: Date.now() }));
}

function readEntry(raw: string | null): { value?: unknown; at?: unknown } {
    try {
        return (raw && JSON.parse(raw)) || {};
    } catch {
        return {};
    }
}

/** Read and clear: the URL a sign-out in this tab asked to end on, if it is still fresh. */
export function consumeAfterSignOut(): string | undefined {
    const { value, at } = readEntry(window.sessionStorage.getItem(KEY));
    window.sessionStorage.removeItem(KEY);

    if (typeof at !== 'number' || Date.now() - at > MAX_AGE_MS) {
        return undefined;
    }

    return value === 'companyHome' ? config.companyURL || undefined : undefined;
}
